module.exports = __webpack_public_path__ + "static/media/GUIDE_0008_02.7b6804de.jpg";